"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkManager = void 0;
const ApsConfiguration_1 = require("./ApsConfiguration");
const ResiliencyConfiguration_1 = require("./ResiliencyConfiguration");
const ApsClient_1 = require("./ApsClient");
const Logger_1 = require("./Logger");
class SdkManager {
    constructor(apsConfiguration, resiliencyConfiguration, authClient, logger) {
        this._apsConfiguration = apsConfiguration !== null && apsConfiguration !== void 0 ? apsConfiguration : new ApsConfiguration_1.ApsConfiguration({});
        this._resiliencyConfiguration =
            resiliencyConfiguration !== null && resiliencyConfiguration !== void 0 ? resiliencyConfiguration : new ResiliencyConfiguration_1.ResiliencyConfiguration();
        this._apsClient = new ApsClient_1.ApsClient(this._resiliencyConfiguration);
        this._authClient = authClient;
        this._logger = logger !== null && logger !== void 0 ? logger : new Logger_1.Logger();
    }
    set logger(logger) {
        this._logger = logger;
    }
    get logger() {
        return this._logger;
    }
    static getInstance(apsConfiguration, resiliencyConfiguration, authClient, logger) {
        return new SdkManager(apsConfiguration, resiliencyConfiguration, authClient, logger);
    }
    get apsClient() {
        return this._apsClient;
    }
    get authClient() {
        return this._authClient;
    }
    get apsConfiguration() {
        return this._apsConfiguration;
    }
    set apsConfiguration(apsConfiguration) {
        this._apsConfiguration = apsConfiguration;
    }
}
exports.SdkManager = SdkManager;
